import { render, staticRenderFns } from "./table-paging-select.vue?vue&type=template&id=04ce44dc&scoped=true"
import script from "./table-paging-select.vue?vue&type=script&lang=js"
export * from "./table-paging-select.vue?vue&type=script&lang=js"
import style0 from "./table-paging-select.vue?vue&type=style&index=0&id=04ce44dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ce44dc",
  null
  
)

export default component.exports